import scroll from "./scroll";

export default {
  mixins: [scroll],
  mounted() {
    window.onhashchange = onhashchange.bind(this);

    function onhashchange() {
      let hash = location.hash.substring(1);

      if (!hash) {
        return;
      }

      if (
        hash === this.acf["scroll-target"] ||
        hash === this.obj["scroll-target"]
      ) {
        this.scroll({
          to: this.$el,
          callback: () => {
            history.replaceState(null, null, " ");
          },
        });
      }
    }
    onhashchange.call(this);
  },
};
